import { CheckCircle } from 'lucide-react';
import { NodeShell } from './NodeShell.tsx';
import { colors } from '../../../config/design-tokens.ts';
import type { PKGNodeComponentProps } from './DecisionNode.tsx';

// Keys on entityType === 'user_story' (schema's real enum value), display
// label stays "Story" — adjudication Q3.
export function StoryNode({ data, isConnectable }: PKGNodeComponentProps) {
  return (
    <NodeShell
      testId="pkg-node-story"
      shape="circle"
      accentColor={colors.semantic.success}
      icon={CheckCircle}
      label={data.summary ?? data.entityId}
      badge={data.badge}
      isConnectable={isConnectable}
    />
  );
}
